import HandleSetPermission from "./page/HandleSetPermission"

const Permission:React.FC = () =>{
    return(
        <HandleSetPermission/>
    )
};
export default Permission;